import { Heading, Modal, TextButton } from '@zillow/constellation-10';
import { TermType } from '@zg-rentals/ts-id-verification-client';
import TermsHtml from './TermsHtml';

export default function NoticeToUsers() {
  return (
    <Modal
      size={{ base: 'fullScreen', md: 'lg' }}
      trigger={<TextButton>Notice to users</TextButton>}
      header={
        <Heading level={2} textStyle="heading-sm">
          Notice to users
        </Heading>
      }
      body={<TermsHtml termType={TermType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER} />}
    />
  );
}
